import { render, staticRenderFns } from "./MembershipForm.vue?vue&type=template&id=245e7b3f&scoped=true"
import script from "./MembershipForm.vue?vue&type=script&lang=js"
export * from "./MembershipForm.vue?vue&type=script&lang=js"
import style0 from "./MembershipForm.vue?vue&type=style&index=0&id=245e7b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e7b3f",
  null
  
)

export default component.exports